module.exports = __webpack_public_path__ + "img/c81e219332400e1610777693d2dcaa7a.svg";